import type { Menu } from '@/admin/types';

/**
 * 根据权限标识列表过滤菜单树
 * - 保留自身 permission 在权限列表中的菜单
 * - 保留有子菜单被保留的父目录菜单
 * - 过滤掉 menuType === 3 的按钮
 */
export const filterMenusByPermissions = (menus: Menu[], permissions: string[]): Menu[] => {
  const result: Menu[] = [];
  for (const menu of menus) {
    if (menu.menuType === 3) continue;
    const filteredChildren = menu.children ? filterMenusByPermissions(menu.children, permissions) : [];
    const hasPermission = !!menu.permission && permissions.includes(menu.permission);
    const hasChildren = filteredChildren.length > 0;
    if (hasPermission || hasChildren) {
      result.push({ ...menu, children: filteredChildren });
    }
  }
  return result;
};
